import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorTextMedium, space2, space6 } = theme();

  return StyleSheet.create({
    body: {
      color: colorTextMedium,
      textAlign: "center",
    },
    container: {
      alignItems: "center",
      flexDirection: "column",
    },
    icon: {
      marginBottom: space6,
    },
    title: {
      marginBottom: space2,
      textAlign: "center",
    },
    wrapper: {
      alignItems: "center",
    },
  });
};

export { style };
